module.exports = __webpack_public_path__ + "static/media/bandera_eua.e94c1cce.png";